module.exports = __webpack_public_path__ + "images/trello-logo-gray.bf59a46c61cdd54c4626.svg";